/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
// Auto-play product videos
(function() {
  function autoplayVideo() {
    // Find the first video's play button (regardless of active state)
    const firstVideoButton = document.querySelector('[data-video] .deferred-media__poster');
    
    console.log('Autoplay script running');
    console.log('Found video button:', firstVideoButton);
    
    if (firstVideoButton) {
      // Click the button to load and play the video
      firstVideoButton.click();
      console.log('Video button clicked!');
    } else {
      console.log('No video button found, retrying...');
      // Try again after a delay if not found
      setTimeout(autoplayVideo, 500);
    }
  }

  // Run after a short delay to ensure DOM is ready
  setTimeout(autoplayVideo, 500);
})();

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
